import { TocItem } from '@/app/shared/models';
import aspectStoreModule from '@/app/aspect/apsect-state';

export const allSectionIdsUnderToc = (tocItem: TocItem): string[] => {
  return allSectionsUnderToc(tocItem).map((item) => item.id);
};

export const allSectionsUnderToc = (tocItem: TocItem, sections: TocItem[] = []): TocItem[] => {
  sections = [...sections, tocItem];

  if (tocItem.children) {
    for (const child of tocItem.children) {
      sections = allSectionsUnderToc(child, sections);
    }
  }

  return sections;
};

export const allSectionIdsUnderPage = (page: string, tocItem: TocItem, sectionIds: string[] = []) => {
  if (tocHrefPagesEquals(page, tocItem.href)) {
    sectionIds = [...sectionIds, tocItem.id];
  }

  if (tocItem.children) {
    for (const child of tocItem.children) {
      sectionIds = allSectionIdsUnderPage(page, child, sectionIds);
    }
  }

  return sectionIds;
};

// determine if the section is on the same page as the parent
export const isChildSection = (
  sectionId: string,
  currentParent: TocItem|null = null,
  children: TocItem[] = []
): { isChild: boolean; parent: TocItem|null } => {
  if (children.length === 0) {
    if (aspectStoreModule.selectedChapter === null || !aspectStoreModule.selectedChapter.children) {
      return { isChild: false, parent: null };
    }

    children = aspectStoreModule.selectedChapter.children;
  }

  for (const item of children) {
    if (item.id === sectionId
      && currentParent !== null
      && tocHrefPagesEquals(item.href, currentParent.href)) {
      return { isChild: true, parent: currentParent };
    }

    if (!item.children) {
      continue;
    }

    const result = isChildSection(sectionId, item, item.children);
    if (result.isChild) {
      return result;
    }
  }

  return { isChild: false, parent: null };
};

export const tocHrefEqualsPage = (page: string, tocHref: string|null): boolean => {
  return tocHref !== null && tocHref.startsWith(page);
};

export const tocHrefPagesEquals = (href1: string|null|undefined, href2: string|null|undefined): boolean => {
  if (!href1 || !href2) {
    return false;
  }

  return href1.split('#')[0] === href2.split('#')[0];
};

export const getContainingChapter = (
  href: string,
  currentChapter: TocItem|null = null,
  tocItems: TocItem[]|null = null
): { item: TocItem; chapter: TocItem; }|null => {
  if (!aspectStoreModule.selectedCourseAspectInstance) {
    return null;
  }

  if (tocItems === null) {
    tocItems = aspectStoreModule.selectedCourseAspectInstance.tocItems;
  }

  for (const tocItem of tocItems) {
    if (tocItem.type === 'chapter') {
      currentChapter = tocItem;
    }

    if (tocItem.children) {
      const found = getContainingChapter(href, currentChapter, tocItem.children);
      if (found !== null) {
        return found;
      }
    }

    if (tocItem.href === href && currentChapter !== null) {
      return {
        item: tocItem,
        chapter: currentChapter
      };
    }
  }

  return null;
};

export const isChapter = (sectionId: string, tocItems: TocItem[]|null = null): boolean => {
  if (!aspectStoreModule.selectedCourseAspectInstance) {
    return false;
  }

  if (tocItems === null) {
    tocItems = aspectStoreModule.selectedCourseAspectInstance.tocItems;
  }

  for (const item of tocItems) {
    if (item.id === sectionId && item.type === 'chapter' && item.children) {
      return true;
    }

    if (item.children) {
      const result = isChapter(sectionId, item.children);
      if (result) {
        return true;
      }
    }
  }

  return false;
};
